import { render } from "./MatchView.vue?vue&type=template&id=0b60f2ec&scoped=true"
import script from "./MatchView.vue?vue&type=script&lang=js"
export * from "./MatchView.vue?vue&type=script&lang=js"

import "./MatchView.vue?vue&type=style&index=0&id=0b60f2ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b60f2ec"]])

export default __exports__